import { GuestOnlyRoute } from '@/features/auth/components/GuestOnlyRoute';

export function PublicLayout() {
  return <GuestOnlyRoute />;
}
